import { useCreateAbacUserMutation } from "../../AbacAppQueries";
import { useCallback, useState } from "react";
import { object, string } from "yup";
import { useFormik } from "formik";
import { useNotification } from "../../../../App/State/Hooks/useNotificationHooks";
import { useModalHooks } from "../../../../App/State/Hooks/useModalHooks";
import { ICreateAbacUser } from "../../../../App/Typings/AbacUser";
import { useDispatch } from "react-redux";
import { updateAbacUser } from "../../../../App/State/Slices/AbacUserSlice";
import { useHistory } from "react-router-dom";

interface ICreateUserFormProps {
  isAdminCreation?: boolean;
}

export default function useCreateUserFormState({
  isAdminCreation,
}: ICreateUserFormProps) {
  const { closeModal } = useModalHooks();
  const { displayError } = useNotification();
  var history = useHistory();

  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState<number>(0);
  const steps = ["Basic User Information", "Attribute Assignement"];

  const { mutate: createNewAbacUser, isLoading: createIsLoading } =
    useCreateAbacUserMutation();

  //Validation for the create app form
  const validationSchema = object().shape({
    firstName: string()
      .trim()
      .max(50, "First Name must be less than 50 characters")
      .required("First Name is required"),
    lastName: string()
      .trim()
      .max(50, "Last Name must be less than 50 characters")
      .required("Last Name is required"),
    emailAddress: string()
      .trim()
      .max(50, "Email Address must be less than 50 characters")
      .required("Email Address is required"),
    phoneNumber: string()
      .trim()
      .max(50, "Phone Number must be less than 50 characters"),
  });

  //Initial create User formik setup
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNumber: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let newUser: ICreateAbacUser = {
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        emailAddress: values.emailAddress.trim(),
        phoneNumber: values.phoneNumber.trim(),
      };
      createUser(newUser);
    },
  });

  const handleCreateModalClose = (event: any, reason: any) => {
    if (!createIsLoading) {
      if (reason === "backdropClick") {
        return;
      } else {
        closeModal();
        setTimeout(() => {
          setActiveStep(0);
        }, 500);
      }
    } else return;
  };

  // Create a new ABAC User
  const createUser = useCallback(
    function submitUser(newAbacUser: ICreateAbacUser) {
      if (!createIsLoading) {
        createNewAbacUser(newAbacUser, {
          onSuccess: (data) => {
            if (isAdminCreation) {
              dispatch(updateAbacUser(data.data));
              history.push(`/adminUserManagement/` + data.data);
              formik.resetForm();
              closeModal();
            }
            dispatch(updateAbacUser(data.data));
            setActiveStep(activeStep + 1);
            formik.resetForm();
          },
        });
      }
    },
    [
      createIsLoading,
      createNewAbacUser,
      displayError,
      dispatch,
      activeStep,
      formik,
    ]
  );

  return {
    getters: {
      activeStep,
      steps,
      formik,
    },
    handlers: { handleCreateModalClose },
  };
}
